import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';

import { Link, useNavigate } from 'react-router-dom';
import { getAdmitCard, getPaymentInfo } from "../AdmitCard/api"
import { updateWizardStatus } from '../../store/auth/actions'
import help from '../../assests/pdf/Departmental Exam User Manual.pdf'
import { checkStatus } from "../../shared/commonFunction";

const Wizard = (props) => {

    const [payment, setPayment] = useState(false)

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        let payment = await getPaymentInfo()

        if (payment.data) {
            setPayment(payment.data)
        }
        let res = await getAdmitCard()
        if (res.code) {
            // console.log(res.data.user_det);
            let wizard = {
                application: checkStatus(res.data?.userDet, "passport"),
                document: checkStatus(res.data?.userDet, "document"),
                updateCenter: res.data.userDet?.is_approved == 1 ? "new" : "disabled",
            }
            props.updateWizardStatus(wizard)
        }


    }

    return (
        <>
            {/* Was two "Step 1"/"Step 2" buttons whose only state was an
                inline backgroundColor:green — no indication of what each step
                was, which one you were on, or what "green" meant. A real step
                bar: numbered, named, with a done/current state. */}
            <ol className='ui_steps'>
                <li className={`ui_step ${props.auth.wizardStatus?.application === 'filled' ? 'is_done' : ''}`}>
                    <Link to='/application-form'>
                        <span className='ui_step_no'>
                            {props.auth.wizardStatus?.application === 'filled'
                                ? <i className='fa fa-check' aria-hidden='true'></i>
                                : 1}
                        </span>
                        <span className='ui_step_text'>
                            <span className='ui_step_name'>Application Form</span>
                            <span className='ui_step_state'>
                                {props.auth.wizardStatus?.application === 'filled' ? 'Completed' : 'Pending'}
                            </span>
                        </span>
                    </Link>
                </li>

                <li className={`ui_step ${props.auth.wizardStatus?.document === 'filled' ? 'is_done' : ''}`}>
                    <Link to='/step2'>
                        <span className='ui_step_no'>
                            {props.auth.wizardStatus?.document === 'filled'
                                ? <i className='fa fa-check' aria-hidden='true'></i>
                                : 2}
                        </span>
                        <span className='ui_step_text'>
                            <span className='ui_step_name'>Upload Documents</span>
                            <span className='ui_step_state'>
                                {props.auth.wizardStatus?.document === 'filled' ? 'Completed' : 'Pending'}
                            </span>
                        </span>
                    </Link>
                </li>

            </ol>

            <div className="card-header">
                <div className='card-header-container'>
                    <div>
                        <Link to={props.redirect}>
                            <button type="button" className="btn btn-warning btn-sm"><i className='fa fa-arrow-left'></i>&nbsp;Back</button>
                        </Link>
                    </div>
                    <div>
                        <i className='fa fa-laptop'></i>{props.title}
                    </div>
                    <div><button
                        // data-bs-toggle="modal"
                        // data-bs-target="#helpModal"
                        onClick={() => window.open(help, "_blank")}
                        type="button"
                        className="btn btn-warning btn-sm"
                    ><i className='fa fa-question'></i>&nbsp;Help</button>
                    </div>
                </div>
            </div>

            {/* modal */}
            <div className="modal fade" id="helpModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Help</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            In case of Any Application related query, Please contact your Pariksha Mitra.<br /><br />


                            Shivam Kumar, Pariksha Mitra - 9113123269<br />

                            Shakti kumar, Pariksha Mitra - 808349066<br />

                            Mayank Kumar, Pariksha Mitra - 8252373042<br />

                            Md. Khalid, Pariksha Mitra - 9795575905<br />
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.Auth
    }
}

const mapDispatchToProps = { updateWizardStatus }
export default connect(mapStateToProps, mapDispatchToProps)(Wizard);